let lightboxMain, lightboxThumbs;

function closeLightbox() {
    const modal = document.getElementById('customLightbox');
    modal.style.display = 'none';
    modal.innerHTML = '';
    if (lightboxMain) lightboxMain.destroy();
    if (lightboxThumbs) lightboxThumbs.destroy();
}

function openDynamicLightbox(startImgSrc) {
    const visibleSlides = document.querySelectorAll('.product-media-slider__slide:not(.hidden) img');
    const images = Array.from(visibleSlides).map(img => ({
        src: img.src,
        alt: img.alt || ''
    }));
    const startIndex = images.findIndex(img => img.src === startImgSrc);

    const modal = document.getElementById('customLightbox');
    modal.innerHTML = `
        <div class="lightbox-backdrop" onclick="closeLightbox()"></div>
            <div class="lightbox-content">
                <div class="swiper lightbox-main">
                <div class="swiper-wrapper">
                    ${images.map(img => `<div class="swiper-slide"><img src="${img.src}" alt="${img.alt}"></div>`).join('')}
                </div>
                <button class="swiper-button-prev lightbox-prev"></button>
                <button class="swiper-button-next lightbox-next"></button>
                </div>
                <div class="swiper lightbox-thumbs"><div class="swiper-wrapper">
                ${images.map(img => `<div class="swiper-slide"><img src="${img.src}" alt="${img.alt}"></div>`).join('')}
                </div>
            </div><button class="lightbox-close" onclick="closeLightbox()">×</button>
        </div>
    `;
    modal.style.display = 'flex';

    document.querySelector('.lightbox-backdrop')?.addEventListener('click', closeLightbox);
    document.querySelector('.lightbox-close')?.addEventListener('click', closeLightbox);

    lightboxThumbs = new Swiper('.lightbox-thumbs', {
        spaceBetween: 10,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
            0: {
                slidesPerView: 'auto',
                direction: 'horizontal',
                freeMode: true,
            },
            768: {
                slidesPerView: 5,
                direction: 'vertical',
                freeMode: true,
            }
        }
    });

    lightboxMain = new Swiper('.lightbox-main', {
        spaceBetween: 10,
        initialSlide: startIndex >= 0 ? startIndex : 0,
        navigation: {
            nextEl: '.lightbox-next',
            prevEl: '.lightbox-prev',
        },
        thumbs: {
            swiper: lightboxThumbs,
        },
    });
    setupZoomFeature();
}

function setupLightboxTriggers() {
  const isZoomOnly = !!document.getElementById('enableZoomOnly');

  const triggers = document.querySelectorAll('.product-media-slider__slide:not(.hidden) img');
  triggers.forEach(img => {
    img.style.cursor = 'zoom-in';

    if (isZoomOnly) {
        const container = img.closest('.product-media-slider__slide');
        container.addEventListener('mouseenter', enableZoomOnHover);
        container.addEventListener('mouseleave', disableZoomOnHover);
    }
    else {
      img.onclick = () => {
        if (window.innerWidth >= 768) {
          openDynamicLightbox(img.src); // modal lightbox
        }
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', setupLightboxTriggers);
document.addEventListener('change', () => setTimeout(setupLightboxTriggers, 300)); // después de cambiar variante
document.addEventListener('shopify:section:load', setupLightboxTriggers);

document.addEventListener('keydown', function (e) {
    if (e.key === "Escape") closeLightbox();
});

let zoomEnabled = false;
let zoomLens;

function handleZoom(e) {
  const container = e.currentTarget;
  const img = container.querySelector('img');
  if (!zoomLens || !zoomEnabled) return;

  const imgRect = img.getBoundingClientRect();

  const x = e.clientX - imgRect.left;
  const y = e.clientY - imgRect.top;

  const percentX = (x / imgRect.width) * 100;
  const percentY = (y / imgRect.height) * 100;

  zoomLens.style.left = `${e.clientX - container.getBoundingClientRect().left - 150}px`;
  zoomLens.style.top = `${e.clientY - container.getBoundingClientRect().top - 150}px`;
  zoomLens.style.backgroundPosition = `${percentX}% ${percentY}%`;
}

function toggleZoomDirect(e) {
  const container = e.currentTarget.parentElement; // el swiper-slide
  const img = e.currentTarget;

  if (window.innerWidth < 768) return; // solo desktop

  if (!zoomEnabled) {
    zoomEnabled = true;
    container.classList.add('zoomed');

    zoomLens = document.createElement('div');
    zoomLens.className = 'zoom-lens';
    zoomLens.style.backgroundImage = `url(${img.src})`;
    container.appendChild(zoomLens);

    container.addEventListener('mousemove', handleZoom);
  } else {
    zoomEnabled = false;
    container.classList.remove('zoomed');
    if (zoomLens) zoomLens.remove();
    container.removeEventListener('mousemove', handleZoom);
    zoomLens = null;
  }
}

function toggleZoom(e) {

    if (window.innerWidth < 768) return;

    const container = e.currentTarget;
    const img = container.querySelector('img');

    if (!zoomEnabled) {
        zoomEnabled = true;
        container.classList.add('zoomed');

        zoomLens = document.createElement('div');
        zoomLens.className = 'zoom-lens';
        zoomLens.style.backgroundImage = `url(${img.src})`;
        container.appendChild(zoomLens);

        container.addEventListener('mousemove', handleZoom);
    } else {
        zoomEnabled = false;
        container.classList.remove('zoomed');
        if (zoomLens) zoomLens.remove();
        container.removeEventListener('mousemove', handleZoom);
        zoomLens = null;
    }
}

function setupZoomFeature() {
  const mainSlides = document.querySelectorAll('.lightbox-main .swiper-slide');

  mainSlides.forEach(slide => {
    slide.removeEventListener('mouseenter', enableZoomOnHover);
    slide.removeEventListener('mouseleave', disableZoomOnHover);

    slide.addEventListener('mouseenter', enableZoomOnHover);
    slide.addEventListener('mouseleave', disableZoomOnHover);
  });
}

function enableZoomOnHover(e) {
  if (window.innerWidth < 768) return;

  const container = e.currentTarget;
  const img = container.querySelector('img');
  if (!img) return;

  zoomEnabled = true;
  container.classList.add('zoomed');

  zoomLens = document.createElement('div');
  zoomLens.className = 'zoom-lens';
  zoomLens.style.backgroundImage = `url(${img.src})`;
  container.appendChild(zoomLens);

  container.addEventListener('mousemove', handleZoom);
}

function disableZoomOnHover(e) {
  const container = e.currentTarget;

  zoomEnabled = false;
  container.classList.remove('zoomed');

  if (zoomLens) zoomLens.remove();
  container.removeEventListener('mousemove', handleZoom);
  zoomLens = null;
}